// extracted by mini-css-extract-plugin
export var md = "_53-4";
export var semantic = "_53-5";
export var sm = "_53-3";
export var text = "_53-6";
export var toggleInput = "_53-0";
export var toggleSwitch = "_53-1";
export var xs = "_53-2";